import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mx-4" },
    [
      _c(
        VRow,
        { staticClass: "mt-6", attrs: { "no-gutters": "" } },
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("app-title", {
                attrs: { texto: "CADASTRO DE DISPENSAS DO DIAGNÓSTICO" },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c(
                VForm,
                {
                  ref: "form",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.onSubmit.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.valid,
                    callback: function ($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid",
                  },
                },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "6" } },
                        [
                          _c("select-simple-unidade", {
                            attrs: {
                              value: _vm.unidade,
                              "mapeamento-id": _vm.diagnostico
                                ? _vm.diagnostico.mapeamento.id
                                : null,
                              disabled: _vm.isEdicao,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "6" } },
                        [
                          _c(VAutocomplete, {
                            staticClass: "mx-2",
                            attrs: {
                              items: _vm.usuariosNaoDispensadosDiagnostico,
                              disabled:
                                !_vm.unidade.selecionado || _vm.isEdicao,
                              rules: _vm.rules.usuario,
                              "item-text": "nome",
                              label: "Servidor",
                              "prepend-icon": "person",
                              placeholder: "Digite para pesquisar...",
                              "return-object": "",
                            },
                            model: {
                              value: _vm.dispensa.usuario,
                              callback: function ($$v) {
                                _vm.$set(_vm.dispensa, "usuario", $$v)
                              },
                              expression: "dispensa.usuario",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "6" } },
                        [
                          _c(VAutocomplete, {
                            staticClass: "mx-2",
                            attrs: {
                              items: _vm.motivos,
                              disabled: !_vm.dispensa.usuario,
                              rules: _vm.rules.motivo,
                              "item-text": "descricao",
                              label: "Motivo",
                              "prepend-icon": "library_books",
                              placeholder: "Digite para pesquisar...",
                              "no-results-text": "Nenhum resultado encontrado.",
                              required: "",
                              "return-object": "",
                            },
                            on: {
                              change: function ($event) {
                                _vm.pesquisa.motivo = ""
                              },
                            },
                            model: {
                              value: _vm.dispensa.motivo,
                              callback: function ($$v) {
                                _vm.$set(_vm.dispensa, "motivo", $$v)
                              },
                              expression: "dispensa.motivo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        [
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          {
                                            staticClass: "mt-4",
                                            attrs: {
                                              color: "primary",
                                              dark: "",
                                              text: "",
                                            },
                                            on: {
                                              click: _vm.toogleMotivoDispensa,
                                            },
                                          },
                                          on
                                        ),
                                        [
                                          _vm._v(" Adicionar "),
                                          _c(
                                            VIcon,
                                            { staticClass: "ml-2" },
                                            [_vm._v(" add_circle ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "Clique para adicionar um motivo de dispensa"
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(VSpacer),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(VSpacer),
                      _c(
                        VRow,
                        {
                          staticClass: "justify-end",
                          attrs: { "no-gutters": "" },
                        },
                        [
                          _c(
                            VRow,
                            { staticClass: "justify-end" },
                            [
                              _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            VBtn,
                                            _vm._g(
                                              {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  disabled:
                                                    !_vm.unidade.selecionado ||
                                                    !_vm.valid,
                                                  color: "primary",
                                                  type: "submit",
                                                },
                                              },
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.isEdicao
                                                      ? "Editar"
                                                      : "Cadastrar"
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "Clique no botão para " +
                                        _vm._s(
                                          _vm.isEdicao ? "editar" : "salvar"
                                        ) +
                                        " a dispensa"
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            VBtn,
                                            _vm._g(
                                              {
                                                staticClass: "mr-3",
                                                attrs: {
                                                  disabled: !_vm.formUpdated,
                                                  color: "primary",
                                                  outlined: "",
                                                },
                                                on: { click: _vm.reset },
                                              },
                                              on
                                            ),
                                            [_vm._v(" Cancelar ")]
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "Clique no botão para cancelar " +
                                        _vm._s(
                                          _vm.isEdicao
                                            ? "a edição"
                                            : "o cadastro"
                                        ) +
                                        " da dispensa"
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("gerenciamento-motivo-dispensa", {
        attrs: {
          toogle: _vm.toogleMotivoDispensa,
          visibilidade: _vm.dialogMotivoDispensa,
          motivos: _vm.motivos,
          dispensas: _vm.dispensas,
          "is-edicao": _vm.isEdicaoMotivo,
          "motivo-update": _vm.motivoUpdate,
        },
        on: {
          hide: _vm.toogleMotivoDispensa,
          return: (value) => _vm.addMotivo(value),
          update: (value) => _vm.updateMotivo(value),
          delete: (value) => _vm.deleteMotivo(value),
          reset: () => _vm.resetMotivo(),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }